var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumbergerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H17C17.8284 0.5 18.5 1.17157 18.5 2C18.5 2.82843 17.8284 3.5 17 3.5H2C1.17157 3.5 0.5 2.82843 0.5 2ZM0.5 7.5C0.5 6.67157 1.17157 6 2 6H17C17.8284 6 18.5 6.67157 18.5 7.5C18.5 8.32843 17.8284 9 17 9H2C1.17157 9 0.5 8.32843 0.5 7.5ZM0.5 13C0.5 12.1716 1.17157 11.5 2 11.5H17C17.8284 11.5 18.5 12.1716 18.5 13C18.5 13.8284 17.8284 14.5 17 14.5H2C1.17157 14.5 0.5 13.8284 0.5 13Z",
    fill: "#6B2C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbergerButton);
export default __webpack_public_path__ + "static/media/humberger_button.a67fc26175e8449ae5b1fd4a293fe040.svg";
export { ForwardRef as ReactComponent };